import React, {useRef} from 'react';
import {Box, useDimensions} from '@chakra-ui/react';
import PodcastsHero from './Podcasts/Components/hero';
import Podcasts from './Podcasts/Components/Podcasts';
// import axios from "axios";
import FullCrossPlus from '../components/FullCrossPlus';


const PodcastsPage = () => {
    // const [podcastData, setPodcastData] = useState(undefined)
    // const [podcastServices, setPodcastServices] = useState(undefined)
    // const [otherPodcasts, setOtherPodcasts] = useState(undefined)
    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;


    // useEffect(() => {
    //     const fetchPodcastsData = async () => {
    //         const data = await axios.get(`/wp-json/wp/v2/posts?_embed&acf_format=standard&slug=culture-and-connection`).then(resp => {
    //             return resp.data[0];
    //         });
    //         const serviceData = await axios.get(`/wp-admin/admin-ajax.php?action=get_podcast_information`).then(resp => {
    //             return resp.data;
    //         });
    //         const otherPods = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&author_id=${data.author}&exclude_post_slug=culture-and-connection`).then(resp => {
    //             return resp.data;
    //         });
    //         setPodcastData(data)
    //         setPodcastServices(serviceData)
    //         setOtherPodcasts(otherPods)
    //     }
    //     fetchPodcastsData()
    // }, [])

    const isMobile = dimen?.contentBox.width < 768;

    return (
        <Box ref={pageRef}>
            {!isMobile && Array(count)
                .fill('')
                .map((_, key) => (
                    <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key} />
                ))}
            <Box px={['5', '10']} pb={10}>
                <PodcastsHero />
                <Podcasts />
            </Box>
        </Box>
    );
};

export default PodcastsPage;
